"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListUtil = void 0;
var ListUtil = /** @class */ (function () {
    function ListUtil() {
    }
    ListUtil.exists = function (source, pred) {
        return source == null ? false : this.first(source, pred) !== undefined;
    };
    ListUtil.first = function (source, pred) {
        if (source != null)
            for (var _i = 0, source_1 = source; _i < source_1.length; _i++) {
                var s = source_1[_i];
                if (pred(s))
                    return s;
            }
        return undefined;
    };
    ListUtil.map = function (source, keyFunc, valFunc) {
        if (source == null)
            return null;
        var result = {};
        for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
            var k = _a[_i];
            result[keyFunc(k)] = valFunc(source[k]);
        }
        return result;
    };
    ListUtil.mapKeys = function (source, keyFunc) {
        return this.map(source, keyFunc, function (v) { return v; });
    };
    ListUtil.mapValues = function (source, keyFunc) {
        return this.map(source, keyFunc, function (v) { return v; });
    };
    return ListUtil;
}());
exports.ListUtil = ListUtil;
//# sourceMappingURL=ListUtil.js.map